import { LOG } from 'src/app/common/util/log';
import { BoTable, CellContent, TableConstructionData } from './types';

function isJson(value: string): boolean {
  return value.length >= 2 && value.startsWith('{') && value.at(1) !== '{';
}

function parseCellContent(value: string | null, columnIndex: number, rowIndex: number): CellContent {
  try {
    if (!value || !isJson(value)) {
      return value ?? '';
    }
    return JSON.parse(value);
  } catch (e) {
    LOG.error('Row', rowIndex, 'Cell', columnIndex, value, e);
    return value;
  }
}

export function parseBoTable(boTable: BoTable): TableConstructionData {
  const table: TableConstructionData = {
    controlInstructions: null,
    headers: null,
    rows: [],
  };

  let rowIndex = 0;
  for (const rawRow of boTable.rows) {
    const row: CellContent[] = [];

    let columnIndex = 0;
    for (const cell of rawRow.cells) {
      const content = parseCellContent(cell.content?.toString() ?? null, columnIndex, rowIndex);
      row.push(content);
      columnIndex += 1;
    }

    if (rowIndex === 0) {
      table.headers = row;
    } else if (rowIndex === 1) {
      table.controlInstructions = row.map(cell => cell.toString());
    } else {
      table.rows.push(row);
    }

    rowIndex += 1;
  }

  return table;
}
